import React from "react";

const Banner = () => {
  return (
    <div className="w-full bg-black pt-[12rem] animate-fadeIn " >
      {/* İçerik alanı */}
      {/* Spot 1: Sağ üst köşeye yakın */}
<div className="absolute top-5 right-5 w-48 h-48 bg-red-500 rounded-full opacity-30 blur-3xl" />

{/* Spot 2: Sol alt köşeye yakın */}
<div className="absolute left-5 w-48 h-48 bg-purple-600 rounded-full opacity-30 blur-3xl" />


      {/* Spot (Blob) 2 */}

      <div className="relative px-6 max-w-6xl mx-auto flex items-center justify-between">
        {/* Yazı Alanı */}
        <div className="w-1/2 pr-4">
          <div className="text-3xl sm:text-6xl md:text-7xl lg:text-8xl font-bold leading-none">
            <span className="text-gray-300">Cihazını </span>
            <span className="bg-gradient-to-r from-red-500 to-purple-600 text-transparent bg-clip-text font-medium">
              Hemen Sat
            </span>
          </div>
        </div>

        {/* Telefon Görseli */}
        <div className="w-1/2 flex justify-end">
          <img
            src="/banner2.png"
            alt="Phone"
            className="object-contain w-2/3 md:w-auto"
          />
        </div>
      </div>
    </div>
  );
};

export default Banner;
